// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header__container-e53ac1 {
  position: absolute;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  height: 64px;
  background: linear-gradient(180deg, var(--addition-40_60) 0%, transparent);
}

.Header__close-c01d6c {
  position: absolute;
  top: 12px;
  inset-inline-end: 12px;
  z-index: 1;
}

.Header__viewers-deec2d {
  min-width: unset;
}

.Header__live-d2a94a {
  background-color: var(--addition-160);
  border-radius: 8px;
  padding: 6px 7px;
  margin-inline-end: 8px;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./src/main/LiveStreaming/InitiatorView/FullScreenView/Header/styles.m.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,0EAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,UAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,8CAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n  box-sizing: border-box;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 64px;\n  background: linear-gradient(180deg, var(--addition-40_60) 0%, transparent);\n}\n\n.close {\n  position: absolute;\n  top: 12px;\n  inset-inline-end: 12px;\n  z-index: 1;\n}\n\n.viewers {\n  min-width: unset;\n}\n\n.live {\n  background-color: var(--addition-160);\n  border-radius: 8px;\n  padding: 6px 7px;\n  margin-inline-end: 8px;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Header__container-e53ac1`,
	"close": `Header__close-c01d6c`,
	"viewers": `Header__viewers-deec2d`,
	"live": `Header__live-d2a94a`
};
module.exports = ___CSS_LOADER_EXPORT___;
